import React from "react";
import { useSelector } from "react-redux";

const Back = React.forwardRef(({ visitingOneBackPrintRef }, ref) => {
  const { printingData } = useSelector((state) => state.printingOldCardReissue);
  return (
    <div
      ref={visitingOneBackPrintRef}
      style={{ boxSizing: "border-box" }}
    >
      <title>DHC Card Back</title>

      <div style={{ height: "1113.5px" }}>
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "start",
              columnGap: 52.37,
              flexDirection: "row-reverse",
              paddingRight: 1.87,
              paddingLeft: 4.5,
              rowGap: 7.79,
              paddingTop: 8.5,
              width: 720,
              fontSize: 8,
            }}
          >
            {printingData?.map((value, index) => {
              return (
                <div
                  key={index}
                  className="item-class-back"
                  style={{
                    backgroundColor: "#ffffff",
                    maxWidth: 330.63,
                    minWidth: 330.63,
                    width: 330.63,
                    maxHeight: 213.21,
                    minHeight: 213.21,
                    height: 213.21,
                    lineHeight: 0,
                    border: "1px solid #f3f3f3",
                    padding: 0,
                    margin: 0,
                    overflow: "hidden",
                  }}
                >
                  <img
                    src={value?.back_image}
                    width={330.63}
                    height={213.21}
                    alt="back_image"
                    style={{
                      width: "100%",
                      height: "100%",
                      lineHeight: 0,
                      padding: 0,
                      margin: 0,
                    }}
                  />
                </div>
              );
            })}
          </div>
        </div>
    </div>
  );
});

export default Back;
